import watch from 'redux-watch';
import template from 'promo-footer-primary-banner.j2';

import { generate } from '../../../core/js/utils/componentUtils';

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-footer-promo',
        watch: 'core.primaryFooterPromo',
        name: 'primaryFooterPromoComponent',
        template: template
    };
    return generate(config, store, overrides);
}
